/**
 * Libellés FR/EN des écrans IA de console, usages compris. Les clés d’usage
 * contenant « : » se traduisent entières ; les montants interpolés sont déjà
 * formatés en dollars depuis les cents de l’API. Ces libellés restent du texte.
 */
export const frIa = {
  titre: 'Intelligence artificielle',
  active: 'IA autorisée',
  coupee: 'IA coupée',
  illisible: 'L’état des interrupteurs est illisible : l’IA est arrêtée par précaution.',
  secours: 'Coupure de secours active (lecture seule) : ARTOSERA_IA_COUPEE=1',
  depense: 'Dépense de {{mois}} : {{montant}}',
  premieres: 'Les 20 premières galeries par dépense',
  seuil: 'Galeries ayant atteint 80 % du plafond',
  aucune: 'Aucune consommation.',
  aucunSeuil: 'Aucune galerie à ce seuil.',
  usagesCoupes: 'Usages coupés',
  aucunUsage: 'Aucun usage coupé.',
  modifier: 'Régler les coupures IA',
  globale: 'Couper toute l’IA',
  motif: 'Motif (obligatoire)',
  confirmer: 'Confirmer',
  annuler: 'Annuler',
  historique: 'Historique des coupures IA',
  historiqueVide: 'Aucune modification.',
  erreur: 'Impossible de terminer cette opération. Réessayez.',
  chargement: 'Chargement de l’IA…',
  enregistre: 'Réglages IA enregistrés.',
  lectureSeule: 'Votre rôle permet uniquement la consultation.',
  plafond: 'Plafond mensuel (USD)',
  plafondAide: 'De 0 à 1 000 dollars, par pas de 0,01. Laissez vide pour le plafond par défaut.',
  effectif: 'Plafond effectif : {{montant}}',
  suspendue: 'Suspendre l’IA de cette galerie',
  suspensionOui: 'IA suspendue pour cette galerie',
  suspensionNon: 'IA autorisée pour cette galerie',
  enregistrer: 'Enregistrer les réglages IA',
  consommations: 'Consommation des 12 derniers mois',
  appels: '{{n}} appels',
  parUsage: 'Détail par usage',
  usages: {
    'voix:apercu': 'Aperçu de la voix',
    'reponse:tri': 'Classement des messages',
    'reponse:brouillon': 'Brouillon de réponse',
    'reponse:relance': 'Relance',
    'reponse:pratique': 'Réponse pratique',
    'catalogage:recto': 'Catalogage du recto',
    'catalogage:verso': 'Catalogage du verso',
    'catalogage:biographie': 'Biographie de l’artiste',
    'studio:texte': 'Rédaction de texte',
    'studio:traduction': 'Traduction',
    'recherche:planifier': 'Recherche : choix des outils',
    'recherche:repondre': 'Recherche : réponse',
    'recherche:approfondir': 'Recherche approfondie',
    'recherche:lire': 'Recherche : lecture de document',
  },
};

export const enIa = {
  titre: 'Artificial intelligence',
  active: 'AI allowed',
  coupee: 'AI switched off',
  illisible: 'The switch state cannot be read: AI is stopped as a precaution.',
  secours: 'Emergency shutdown active (read only): ARTOSERA_IA_COUPEE=1',
  depense: 'Spend for {{mois}}: {{montant}}',
  premieres: 'Top 20 galleries by spend',
  seuil: 'Galleries at 80% of their limit',
  aucune: 'No usage.',
  aucunSeuil: 'No gallery at this threshold.',
  usagesCoupes: 'Disabled usages',
  aucunUsage: 'No disabled usages.',
  modifier: 'Manage AI shutdowns',
  globale: 'Switch off all AI',
  motif: 'Reason (required)',
  confirmer: 'Confirm',
  annuler: 'Cancel',
  historique: 'AI shutdown history',
  historiqueVide: 'No changes.',
  erreur: 'This operation could not be completed. Try again.',
  chargement: 'Loading AI…',
  enregistre: 'AI settings saved.',
  lectureSeule: 'Your role allows viewing only.',
  plafond: 'Monthly limit (USD)',
  plafondAide: 'From 0 to 1,000 dollars, in steps of 0.01. Leave blank to use the default limit.',
  effectif: 'Effective limit: {{montant}}',
  suspendue: 'Suspend AI for this gallery',
  suspensionOui: 'AI suspended for this gallery',
  suspensionNon: 'AI allowed for this gallery',
  enregistrer: 'Save AI settings',
  consommations: 'Usage over the last 12 months',
  appels: '{{n}} calls',
  parUsage: 'Breakdown by usage',
  usages: {
    'voix:apercu': 'Voice preview',
    'reponse:tri': 'Message sorting',
    'reponse:brouillon': 'Reply draft',
    'reponse:relance': 'Follow-up',
    'reponse:pratique': 'Practical reply',
    'catalogage:recto': 'Front cataloguing',
    'catalogage:verso': 'Back cataloguing',
    'catalogage:biographie': 'Artist biography',
    'studio:texte': 'Text writing',
    'studio:traduction': 'Translation',
    'recherche:planifier': 'Search: tool choice',
    'recherche:repondre': 'Search: answer',
    'recherche:approfondir': 'In-depth search',
    'recherche:lire': 'Search: document reading',
  },
};
